var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "login-button",
          attrs: {
            slot: "activator",
            shrink: "",
            outlined: "",
            color: "primary",
          },
          on: {
            click: function ($event) {
              return _vm.setProfileOpen(true)
            },
          },
          slot: "activator",
        },
        [
          _c(
            "v-icon",
            { staticClass: "profile-icon primary--text", attrs: { large: "" } },
            [_vm._v("account_circle")]
          ),
          _vm.$vuetify.breakpoint.lgAndUp
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.user.email.substring(0, _vm.user.email.indexOf("@"))
                  )
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { fullscreen: "", transition: "dialog-bottom-transition" },
          model: {
            value: _vm.profileOpen,
            callback: function ($$v) {
              _vm.profileOpen = $$v
            },
            expression: "profileOpen",
          },
        },
        [
          _c("v-card", { attrs: { id: "profile" } }, [
            _c(
              "div",
              { staticClass: "bsn-container" },
              [
                _c("div", {
                  staticClass: "close",
                  on: {
                    click: function ($event) {
                      return _vm.setProfileOpen(false)
                    },
                  },
                }),
                _c(
                  "v-flex",
                  {
                    staticClass: "d-flex flex-column",
                    attrs: { xs10: "", md6: "", "justify-center": "" },
                  },
                  [
                    _c(
                      "v-card",
                      { staticClass: "mb-3", attrs: { elevation: "5" } },
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "pa-0 flex-nowrap" },
                          [
                            _c(
                              "v-avatar",
                              {
                                staticClass: "rounded-0",
                                attrs: { size: "56" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "p-6 icon-profile",
                                    attrs: { color: "white" },
                                  },
                                  [_vm._v("perm_identity")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "text-nowrap text-truncate" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ma-0 pa-0 ml-4 text-body-1 text-truncate",
                                  },
                                  [_vm._v(_vm._s(_vm.user.ragioneSociale))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card",
                      { staticClass: "mb-3", attrs: { elevation: "5" } },
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "pa-0 flex-nowrap" },
                          [
                            _c(
                              "v-avatar",
                              {
                                staticClass: "rounded-0",
                                attrs: { size: "56" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "p-6 icon-profile",
                                    attrs: { color: "white" },
                                  },
                                  [_vm._v("mail_outline")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "text-nowrap text-truncate" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ma-0 pa-0 ml-4 text-body-1 text-truncate",
                                  },
                                  [_vm._v(_vm._s(_vm.user.email))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card",
                      { staticClass: "mb-3", attrs: { elevation: "5" } },
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "pa-0 flex-nowrap" },
                          [
                            _c(
                              "v-avatar",
                              {
                                staticClass: "rounded-0",
                                attrs: { size: "56" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "p-6 icon-profile",
                                    attrs: { color: "white" },
                                  },
                                  [_vm._v("business")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "text-nowrap text-truncate" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ma-0 pa-0 ml-4 text-body-1 text-truncate",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.user.street) +
                                        ", " +
                                        _vm._s(_vm.user.city)
                                    ),
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ma-0 pa-0 ml-4 text-body-1 text-truncate",
                                  },
                                  [_vm._v(_vm._s(_vm.user.partitaIva))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card-actions",
                      [
                        _c(
                          "v-layout",
                          { attrs: { wrap: "", "justify-end": "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { text: "", color: "white" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setProfileOpen(false)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("message.Chiudi")))]
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: { text: "", color: "white" },
                                on: { click: _vm.logout },
                              },
                              [_vm._v("LOGOUT")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { class: { dark: _vm.darkTheme }, attrs: { id: "tabs" } },
              [
                _c(
                  "v-toolbar",
                  [
                    _c(
                      "v-tabs",
                      {
                        attrs: { grow: "", centered: "", "icons-and-text": "" },
                        model: {
                          value: _vm.currentTab,
                          callback: function ($$v) {
                            _vm.currentTab = $$v
                          },
                          expression: "currentTab",
                        },
                      },
                      [
                        _c("v-tabs-slider", { attrs: { color: "primary" } }),
                        _c(
                          "v-tab",
                          {
                            staticClass: "tab-icon",
                            attrs: { href: "#tab-favorites" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("message.Preferiti")) +
                                " (" +
                                _vm._s(_vm.configurations.length) +
                                ") "
                            ),
                            _c("v-icon", [_vm._v("favorite")]),
                          ],
                          1
                        ),
                        _c(
                          "v-tab",
                          {
                            staticClass: "tab-icon",
                            attrs: { href: "#tab-cart" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("message.Carrello")) +
                                " (" +
                                _vm._s(_vm.cartRows.length) +
                                ") "
                            ),
                            _c("v-icon", [_vm._v("shopping_cart")]),
                          ],
                          1
                        ),
                        _c(
                          "v-tab",
                          {
                            staticClass: "tab-icon",
                            attrs: { href: "#tab-history" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("message.storico_ordini")) +
                                " "
                            ),
                            _c("v-icon", [_vm._v("history")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-tabs-items",
                  {
                    staticClass: "tabitem",
                    attrs: { touchless: "" },
                    model: {
                      value: _vm.currentTab,
                      callback: function ($$v) {
                        _vm.currentTab = $$v
                      },
                      expression: "currentTab",
                    },
                  },
                  _vm._l(_vm.items, function (item) {
                    return _c(
                      "v-tab-item",
                      { key: item, attrs: { value: "tab-" + item } },
                      [
                        _c(item, {
                          tag: "components",
                          attrs: {
                            configurations: _vm.configurations,
                            haveConfigurations: _vm.haveConfigurations,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }